export const PLAN_COMPTABLE = [
  { compte: '3200', lib: 'Ventes de marchandises', type: 'produit' },
  { compte: '3400', lib: 'Prestations de services', type: 'produit' },
  { compte: '4000', lib: 'Achats de marchandises', type: 'charge' },
  { compte: '4400', lib: 'Charges de sous-traitance', type: 'charge' },
  { compte: '5000', lib: 'Salaires', type: 'charge' },
  { compte: '5700', lib: 'Charges sociales (AVS/LPP)', type: 'charge' },
  { compte: '6000', lib: 'Loyer / locaux', type: 'charge' },
  { compte: '6200', lib: 'Véhicules & carburant', type: 'charge' },
  { compte: '6500', lib: 'Frais administratifs', type: 'charge' },
  { compte: '6570', lib: 'Repas & représentation', type: 'charge' },
  { compte: '6600', lib: 'Publicité / marketing', type: 'charge' },
];

/**
 * Familles de frais : compte, icône et type de taux de TVA déductible.
 *
 * <p>`tva` nomme un type — `normal`, `reduit`, `hebergement` — et non un
 * nombre : la valeur est celle en vigueur à la date de la dépense
 * (`lib/tva.js`), réglée dans Réglages → Documents. `null` : la dépense
 * n'ouvre pas droit à déduction (assurances, intérêts, loyers…).
 */
export const FRAIS_CAT = {
  soustraitance: { lib: 'Sous-traitance', compte: '4400', icon: '🔨', tva: 'normal' },
  outillage: { lib: 'Outillage', compte: '6100', icon: '\ud83e\uddf0', tva: 'normal' },
  juridique: { lib: 'Frais juridiques', compte: '6530', icon: '\u2696\ufe0f', tva: 'normal' },
  dechets: {
    lib: 'D\u00e9chetterie / d\u00e9chets',
    compte: '6460',
    icon: '\ud83d\uddd1\ufe0f',
    tva: 'normal',
  },
  assurance: {
    lib: 'Assurances (RC, entreprise)',
    compte: '6300',
    icon: '\ud83d\udee1\ufe0f',
    tva: null,
  },
  interets: {
    lib: 'Int\u00e9r\u00eats (cr\u00e9dits, dettes)',
    compte: '6800',
    icon: '\ud83d\udcb3',
    tva: null,
  },
  bancaire: { lib: 'Frais bancaires', compte: '6940', icon: '\ud83c\udfe6', tva: null },
  menage: { lib: 'M\u00e9nage / nettoyage', compte: '6040', icon: '\ud83e\uddf9', tva: 'normal' },
  formation: {
    lib: 'Formation / cotisations',
    compte: '5820',
    icon: '\ud83d\udcda',
    tva: 'normal',
  },
  dons: { lib: 'Dons (utilit\u00e9 publique)', compte: '6960', icon: '\ud83c\udf81', tva: null },
  leasing: { lib: 'Leasing v\u00e9hicule', compte: '6260', icon: '\ud83d\ude97', tva: 'normal' },
  // Une voiture achetée n'est pas une charge de l'année : elle s'amortit
  // (Compta → Véhicules). Sa TVA se récupère, elle, à l'achat.
  achat_vehicule: { lib: 'Achat véhicule (amorti)', compte: '1530', icon: '🚙', tva: 'normal' },
  // L'essence avait disparu des catégories : le patron ne la trouvait pas et
  // la rangeait sous « Véhicule ». Compte 6210, carburants du plan PME suisse.
  carburant: { lib: 'Carburant / essence', compte: '6210', icon: '⛽', tva: 'normal' },
  vehicule: { lib: 'Véhicule (entretien)', compte: '6200', icon: '🚐', tva: 'normal' },
  // Repas et café pris sur place : taux normal (8.1 %), comme sur le ticket ;
  // le taux réduit ne vaut que pour la nourriture achetée à emporter.
  repas: { lib: 'Repas / repr.', compte: '6570', icon: '🍽', tva: 'normal' },
  materiel: { lib: 'Matériel', compte: '4000', icon: '🔧', tva: 'normal' },
  loyer: { lib: 'Loyer', compte: '6000', icon: '🏠', tva: null },
  admin: { lib: 'Administratif', compte: '6500', icon: '📎', tva: 'normal' },
  pub: { lib: 'Publicité', compte: '6600', icon: '📣', tva: 'normal' },
  billets_avion: { lib: "Billets d'avion", compte: '6230', icon: '✈️', tva: null },
  communications: { lib: 'Communications', compte: '6510', icon: '📱', tva: 'normal' },
  divertissements: { lib: 'Divertissements', compte: '6640', icon: '🎭', tva: 'normal' },
  energie: { lib: 'Eau, électricité, etc.', compte: '6400', icon: '💡', tva: 'normal' },
  epicerie: { lib: 'Épicerie généraliste', compte: '6571', icon: '🛒', tva: 'reduit' },
  fournitures: { lib: 'Fournitures de bureau', compte: '6503', icon: '🖊', tva: 'normal' },
  port: { lib: 'Frais de port', compte: '6105', icon: '📦', tva: 'normal' },
  loc_voiture: { lib: 'Location de voiture', compte: '6260', icon: '🚗', tva: 'normal' },
  location_bail: { lib: 'Location, bail', compte: '6001', icon: '🏢', tva: null },
  logement: { lib: 'Logement', compte: '6661', icon: '🏨', tva: 'hebergement' },
  nourriture: { lib: 'Nourriture et boissons', compte: '6572', icon: '🍔', tva: 'reduit' },
  reparation: { lib: 'Réparation et entretien', compte: '6100', icon: '🛠', tva: 'normal' },
  sante: { lib: 'Santé', compte: '6580', icon: '🩺', tva: null },
  transports: { lib: 'Transports', compte: '6220', icon: '🚆', tva: 'normal' },
  vetements: { lib: 'Vêtements', compte: '6590', icon: '👕', tva: 'normal' },
  voyage: { lib: 'Voyage', compte: '6230', icon: '🧳', tva: 'normal' },
  cafe: { lib: 'Café', compte: '6573', icon: '☕', tva: 'normal' },
  stationnement: { lib: 'Stationnement / parking', compte: '6221', icon: '🅿️', tva: 'normal' },
  // Les assurances payées d'un coup pour l'année : voiture, perte de gain.
  assurance_vehicule: { lib: 'Assurance véhicule', compte: '6230', icon: '🚐', tva: null },
  perte_gain: { lib: 'Assurance perte de gain', compte: '5740', icon: '🤒', tva: null },
  // La caisse de pension (2ᵉ pilier) : Nest, fondation collective… sans TVA.
  lpp: { lib: 'Caisse de pension (LPP)', compte: '5720', icon: '🏦', tva: null },
  // La facture de la caisse AVS pour les salaires des employés (part
  // patronale et part retenue) : ce n'est pas l'AVS personnelle du patron.
  charges_sociales: {
    lib: 'Charges sociales des employés (caisse AVS)',
    compte: '5700',
    icon: '👷',
    tva: null,
  },
  // Payé à l'État : ni une dépense ni de la TVA récupérable. La TVA reversée
  // a été encaissée chez les clients ; l'AVS et les impôts sont déjà estimés
  // sur le bénéfice. Ces paiements remplissent « Déjà payé » de l'accueil.
  etat_tva: { lib: 'TVA payée (AFC)', compte: '2200', icon: '🧾', tva: null, etat: 'tva' },
  etat_avs: { lib: 'AVS / AI / APG payée', compte: '2270', icon: '🏛', tva: null, etat: 'avs' },
  etat_impots: { lib: 'Impôts payés', compte: '2208', icon: '🏛', tva: null, etat: 'impots' },
};
